import { useEffect, useRef, useState } from 'react'
import { addMarksData, removeMarksData } from './SlateFunction';
import { PiDropSlash } from "react-icons/pi";

export default function ColorPicker({ editor, marks }) {
    const [showOptions, setShowOptions] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowOptions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Close dropdown when ESC key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setShowOptions(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <div ref={dropdownRef} className='relative' style={{display: 'flex', flexDirection: 'row'}}>
            <button 
                type="button"
                id="color-button"
                onMouseDown={(e) => {
                    e.preventDefault();
                    setShowOptions(prev => !prev)
                }}
                className={`toolbar-button ${showOptions ? 'bg-gray-200' : ''}`}
            >
                {/* icon */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22px"
                    height="25px"
                    viewBox="0 -960 960 960"
                >

                    <path
                        fill='currentcolor'
                        d="M257 -336 437 -816h86l180 480h-83l-43-123H384l-44 123h-83Zm151-192h144l-70-194h-4l-70 194Z"
                    />


                    <path
                        fill={ marks['color'] ? marks['color'] : 'currentcolor'}
                        d="M96 0v-192h768V0H96Z"
                    />
                </svg>
            </button>
            {showOptions &&
                <div className='color-picker-dropdown' style={{display: 'flex', flexDirection: 'row'}}>
                    <div className='color-picker-options' style={{display: 'flex', flexDirection: 'row' }}>
                        <div
                            className="toolbar-button"
                            onMouseDown={(e) => {
                                e.preventDefault();
                                addMarksData(editor, { 'format': 'color', 'value': '#259b24' })
                                setShowOptions(false);

                            }}
                            style={{backgroundColor: '#259b24', width: '20px', height: '20px', cursor: 'pointer', borderRadius: '4px', zIndex: 1000}}
                            >
                        </div>

                        <div
                            className="toolbar-button"
                            onMouseDown={(e) => {
                                e.preventDefault();
                                addMarksData(editor, { 'format': 'color', 'value': '#d93025' })
                                setShowOptions(false);

                            }}
                            style={{backgroundColor: '#d93025', width: '20px', height: '20px', cursor: 'pointer', borderRadius: '4px'}}
                            >
                        </div>
                                               
                    </div>
                    <div className='text-center px-3 pb-3'>
                        <div 
                            className="toolbar-button"
                            onMouseDown={(e) => {
                                e.preventDefault();
                                removeMarksData(editor, { 'format': 'color' });
                                setShowOptions(false);
                            }}
                            style={{cursor: 'pointer', width: '20px', height: '20px', backgroundColor: '#ffffffff', fontWeight: 'bold', color: 'black', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                        >
                           <PiDropSlash />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


